<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref, onMounted, defineExpose, getCurrentInstance } from "vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import { useAlertStore } from "../../../../../stores/alertStore";
const { $confirm, $alert } = useAlertStore();
const { $gb } = getCurrentInstance().appContext.config.globalProperties;

const baseModal = ref(null);
const resolvePromise = ref(null);

const selectedIndex = ref(null);
const selectedItem = ref(null);
const editMode = ref(false); // 등록 or 수정

const selectFinalEdu = (item, i) => {
    selectedIndex.value = i;
    selectedItem.value = item;
};

onMounted(()=>{
    setTimeout(()=>{
        baseModal.value.isAdminWrap = true;
    }, 500);
})

const items = ref([]); // 학력 목록

const show = () => {
    baseModal.value.open();
    return new Promise((resolve, _) => {
        resolvePromise.value = resolve;
    });
};

const confirm = () => {
    baseModal.value.close();
    resolvePromise.value({
        ok: true,
        selectedItem: selectedItem.value,
    });
};

const cancel = () => {
    baseModal.value.close();
    resolvePromise.value({
        ok: false,
        selectedItem: null,
    });
};

const init = (eduHistoryList, isEditMode, _selectedIndex) => {
    selectedIndex.value = null;
    if (eduHistoryList) {
        const scv = sessionStorage.getItem('systemCodeValues');
        let orderMap = {};
        if (scv) {
            let parsed;
            try { parsed = JSON.parse(scv); } catch { parsed = null; }
            let schoolGb;
            if (Array.isArray(parsed)) {
                schoolGb = parsed.find(v => v && v.codeName === 'SCHOOL_GB');
            } else if (parsed && parsed.codeName === 'SCHOOL_GB') {
                schoolGb = parsed;
            }
            if (schoolGb && Array.isArray(schoolGb.codeValues)) {
                orderMap = Object.fromEntries(schoolGb.codeValues.map(cv => [cv.codeValue, cv.order]));
            }
        }

        const normYm = (v) => {
            if (!v) return 0;
            const s = String(v).replace('.', '');
            if (s.length !== 6) return 0;
            const n = Number(s);
            return Number.isNaN(n) ? 0 : n;
        };

        const wrapped = eduHistoryList.map((item, idx) => ({ item, idx }));
        wrapped.sort((a, b) => {
            const oa = orderMap[a.item.schoolGb] || 0;
            const ob = orderMap[b.item.schoolGb] || 0;
            if (ob !== oa) return ob - oa;
            const ga = a.item.eduTenureGb === '01' ? normYm(a.item.endYm) : 0;
            const gb = b.item.eduTenureGb === '01' ? normYm(b.item.endYm) : 0;
            if (gb !== ga) return gb - ga;
            const ra = typeof a.item.order === 'number' ? a.item.order : a.idx;
            const rb = typeof b.item.order === 'number' ? b.item.order : b.idx;
            return rb - ra;
        });

        const sorted = wrapped.map(w => w.item);
        items.value = sorted;
        const idx = sorted.findIndex((item) => item.finalYn === 'Y');
        selectedIndex.value = idx !== -1 ? idx : 0;
        selectedItem.value = sorted[selectedIndex.value];
    }
    editMode.value = !!isEditMode;
};

defineExpose({
    show,
    init,
})

</script>
<template>
    <Modal ref="baseModal">
        <div class="modal-inner sm-size request-modal">
            <div class="modal-title">
                <h3>최종 학력 {{ editMode ? '수정' : '확인' }}</h3>
                <!-- <button class="close" @click="cancel"></button> -->
            </div>
            <div class="modal-body">
                <div class="">
                    <div class="">
                        <p><b>최종학력은 고학력/최신 학력 기준으로 반영되며, 학력 요약정보에 반영될 최종학력을 확인(선택)해 주세요.</b></p>
                        <ul class="edu-list">
                            <li :class="{ selected: selectedIndex === index }" v-for="(item, index) in items" @click="selectFinalEdu(item, index)">
                                <div class="item-title">{{ $gbNameKR('SCHOOL_GB', item.schoolGb) }}</div>
                                <div class="item-sub">{{ item.schoolName }}{{ item.majorName ? ` / ${item.majorName}` : '' }}{{ item.schoolGb !== '05' ? ` / ${$gbNameKR('EDU_TENURE_GB', item.eduTenureGb)}` : '' }}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="modal-footer" :style="{ 'display': 'flex !important', 'gap': '1rem' }">
                <KSASecondaryButton text="취소" @click="cancel" />
                <KSAPrimaryButton :text="editMode ? '수정' : '확인 완료'" @click="confirm" :disabled="selectedIndex === null" />
            </div>
        </div>
    </Modal>
</template>
<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.modal-inner {
    .close {
        top: 23px !important;
    }
}

.edu-list {
    list-style: none;
    padding: 0;
    margin: 12px 0 0 0;
}

.edu-list li {
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 12px 34px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: border-color .11s, box-shadow .11s, background-color .11s;
    text-align: left;
}

.edu-list li .item-title {
    font-weight: 600;
}

.edu-list li .item-sub {
    color: #666;
    font-size: 13px;
    margin-top: 4px;
}

.edu-list li.selected {
    border-color: #2b74e6;
    background-color: rgba(43, 116, 230, 0.07);
    box-shadow: 0 0 0 2px rgba(43, 116, 230, 0.15) inset;
}
</style>
